import dayjs from 'dayjs'
import 'dayjs/locale/ja';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime)
dayjs.locale('ja');
import Gdfs from "gdrive-fs";
import { importDB, exportDB } from "dexie-export-import";

export const gdMixin =  {
  data() {
    return {
      isGdSignin: false,
      fileStat: "",
      localLastUpdate: "",
      cloudLastUpdate: ""
    };
  },
  methods:{
    localToCloud: async function(){
      this.gdApiInit();
    },
    gdApiInit: async function() {
      const params = {};
      params.clientId =
        "181186523944-rpmtnlr14lbtheirm6q5i6jgvil1ulsp.apps.googleusercontent.com";
      params.clientSecret = "sL8WHq8Bs3FKDljPRdX42Q6n";
      params.discoveryDocs = [
        "https://www.googleapis.com/discovery/v1/apis/drive/v3/rest"
      ];
      params.scope = ["https://www.googleapis.com/auth/drive.appdata"].join(
        " "
      );
      await Gdfs.loadApi(params);
      await this.gdCheckSignin();
    },
    setLocalLastUpdate: async function(){
      const dbupdate = await this.$db.pots
        .orderBy("updated_at")
        .desc()
        .toArray();
      this.localLastUpdate =
        dbupdate.length > 0 ? dbupdate[0].updated_at : null;
    },
    setCloudDataset: async function() {
      const params = {
        spaces: "appDataFolder",
        fields: "nextPageToken, files(id, name, modifiedTime)",
        pageSize: 100,
        orderBy: "modifiedTime desc"
      };
      const dir = await Gdfs.getFileList(params);

      if (dir.files.length === 0) {
        this.fileStat = await Gdfs.createFile("appDataFolder", "potly_db.json");
      } else {
        this.fileStat = dir.files[0];
      }
    },
    gdSiginIn: async function() {
      await Gdfs.signIn();
      this.gdCheckSignin();
    },
    gdSiginOut: async function() {
      // console.log(Gdfs);
      await Gdfs.signOut();
      this.isGdSignin = false;
    },
    gdCheckSignin: async function() {
      this.isGdSignin = await Gdfs.isSignedIn();
    },
    gdUpload: async function() {
      // this.message = "Google Driveにデータをアップロードしています。";
      // let dbFile = await Gdfs.getFileResource({fileId: dbFileId, fields: "modifiedTime, size"})

      const blob = await exportDB(this.$db);
      await Gdfs.updateFile(this.fileStat.id, "application/json", blob);
      this.message = "アップロードが完了しました。";
    },
    gdDownload: async function() {
      // console.log(Gdfs.isSignedIn());
      this.message = "Google Driveからpotlyデータをダウンロードしています。";

      const dbData = await Gdfs.downloadFile(this.fileStat.id);
      await this.$db.delete();
      await importDB(new Blob([dbData], { type: "text/plan" }));
      this.message = "復元が完了しました。";
      window.location.reload();
    }
  }
}
